<template lang="html">
<div class="pgInner euserEdit">

    <div class="headBar">新建用户</div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">

        <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="false">

          <div class="textLine clearfix">
                <div class="itemGp">
                      <div class="iName">真实姓名</div>
                      <div class="iContent">
                          <el-form-item prop="name">
                              <el-input v-model="params.name" class="iInp" size="middle" />
                          </el-form-item>
                      </div>
                </div>
                <div class="itemGp">
                      <div class="iName">手机号</div>
                      <div class="iContent">
                          <el-form-item prop="phoneNumber">
                              <el-input v-model="params.phoneNumber" :disabled="true" class="iInp"  size="middle" />
                          </el-form-item>
                      </div>
                </div>

                <!-- <div class="itemGp">
                      <div class="iName">微信</div>
                      <div class="iContent">
                          <el-form-item prop="wechat">
                              <el-input v-model="params.wechat" class="iInp" size="middle" />
                          </el-form-item>
                      </div>
                </div> -->

          </div>

          <div class="textLine clearfix">

                

                <div class="itemGp">
                      <div class="iName">所属企业</div>
                      <div class="iContent">
                          <el-form-item prop="cqjQiyeEnterpriseId">
                            <el-select
                              style="width:270px;"
                              v-model="params.cqjQiyeEnterpriseId"
                              filterable
                              remote
                              placeholder="请输入关键词"
                              size="medium"
                              @change="handleChange"
                              :remote-method="entSeek"
                              :loading="loading">
                                <el-option
                                  v-for="item in entArr"
                                  :key="item.id"
                                  :label="item.companyName"
                                  :value="item.id">
                                </el-option>
                              </el-select>
                          </el-form-item>
                      </div>
                </div>

          </div>

          <div class="textLine clearfix">

                <div class="itemGp">
                      <div class="iName">身份</div>
                      <div class="iContent radioContent">
                          <el-radio-group v-model="radio" @change="radioChange">
                            <el-radio :label="1">普通用户</el-radio>
                            <el-radio :label="2">主管理员</el-radio>
                            <el-radio :label="3">子管理员</el-radio>
                          </el-radio-group>
                      </div>
                </div>

          </div>

        </el-form>

    </div>

    <div class="pagefoot">

      <div v-if="pgState" class="loading">
           <span v-if="pgState == 1">初始化中...</span>
           <span v-if="pgState == 2">数据保存中...</span>
           <i class="el-icon-loading"></i>
      </div>
      <div v-else>
           <el-button @click="goReturn" plain size="small">取消</el-button>
           <el-button @click="directSave" type="primary" size="small">保存</el-button>
      </div>

    </div>

</div>
</template>

<script>

import { createEntUser, entUserItem, userUpdate, changePhone } from "@/api/enterprise/index";
import { getEnterpriseList } from "@/api/attes/attestation";


var mobelPhone = (rule, val, callback) => {      // 手机验证
  var pattern = /^1(3|4|5|7|8)\d{9}$/;

  if (val == '') {
    callback(new Error('请输入手机号'));
  } else if (!pattern.test(val)) {
    callback(new Error('手机号格式错误！'));
  } else {
    callback();
  }
};


export default {
  computed: {
    lineStr: function () {
      var str = 'width:60px;';
      str = str + "left:" + this.navX + "px;";
      return str;
    },
    pgState: function () {
      var state = 0;
      if (this.id && this.readyKey !== 3) {
        state = 1;
      }

      if (this.uploadIng) {
        state = 2;
      }

      return state;
    }
  },
  data() {
    return {

      id: '',
      userId: '',
      navs: ['基本信息', '', '主页信息'],
      navAct: 0,
      navX: 15,
      pageH: '',
      readyKey: 0,
      uploadIng: false,

      radio: 1,

      entArr: [],

      params: {
        cqjQiyeEnterpriseId: '',
        enterpriseName: '',
        name: '',
        wechat: '',
        isAdmin: 2,
        status: 1,
        adminType: '',
        phoneNumber: ''
      },

      rules: {
        cqjQiyeEnterpriseId: [{
          required: true,
          trigger: 'blur'
        }],
        enterpriseName: [{
          required: true,
          trigger: 'blur'
        }],
        // wechat:[{
        //    required: true,
        //    trigger: 'blur'
        // }],
        name: [{
          required: true,
          trigger: 'blur'
        }],
        phoneNumber: [{ validator: mobelPhone, trigger: 'blur' }]
      }

    }
  },

  methods: {
    goReturn: function () {
      this.$router.go(-1);
    },

    entSeek: function (e) {
      var vues = this;
      var key = e.replace(/\s+/g, '');
      if (key) {
        getEnterpriseList({
          status: '',
          keyword: key,
          sort: 2,
          no: 1,
          size: 12
        }).then(res => {
          vues.entArr = res.enterpriseList;
        })
      }
    },

    directSave: function () {
      var vues = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          createEntUser({ enterprisePerson: vues.params }).then(res => {
            vues.$router.push('user_list');
          });
          userUpdate({ nickname: this.params.name, userId: this.params.userId, phone: this.params.phoneNumber });
        } else {
          vues.$message.error('信息未填写完成！');
        }
      })
    },

    tabChange: function (e, inx) {

      var tabNavs = this.$refs.tabNavs;
      this.navAct = inx;
      this.navX = e.target.offsetLeft;

    },
    pageFix: function () {
      this.pageH = document.documentElement.clientHeight - 205;
    },

    radioChange: function (e) {
      if (e == 1) {
        this.params.isAdmin = 2;
        this.params.adminType = '';
      } else if (e == 2) {
        this.params.isAdmin = 1;
        this.params.adminType = 1;
      } else if (e == 3) {
        this.params.isAdmin = 1;
        this.params.adminType = 2;
      }
    },

    handleChange: function (e) {
      this.entArr.forEach(item => {
        if (item.id == e) {
          this.params.enterpriseName = item.companyName;
        }
      })
    },

    readyHandle: function () {
      this.readyKey++;
    },

    prevSet: function () {

      var vues = this;
      var querys = this.$route.query;

      if (querys.id) {
        entUserItem({ id: querys.id }).then(res => {
          vues.id = querys.id;

          vues.params = res.enterprisePerson;
          vues.readyKey = 3;
          this.entSeek(vues.params.enterpriseName);
          if (vues.params.isAdmin == 1) {
            if (vues.params.adminType == 1) {
              vues.radio = 2;
            } else {
              vues.radio = 1;
            }
          }
        })
      }

      // 底部定位
      this.pageFix();
    },

  },

  created: function () {
    var vues = this;
    var querys = this.$route.query;

    this.prevSet();
    $(window).on('resize', function () {
      vues.pageFix();
    })

  },

  beforeDestroy: function () {
    $(window).off('resize');
  }


}
</script>

<style lang="scss" scoped>
.pgInner {
  background: #f5f5f5;
}

.headBar {
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding-left: 20px;
  background: white;
}

.euserEdit .pgbody {
  margin: 20px;
  padding: 20px;
  font-size: 15px;
  background: white;
}

.textLine {
  margin-bottom: 20px;
  font-size: 15px;
}

.textLine .itemGp {
  width: 36%;
  height: 45px;
  float: left;
  position: relative;
}

.textLine .itemGp .iName {
  width: 80px;
  padding-top: 9px;
  float: left;
}

.textLine .itemGp .iContent {
  margin-left: 80px;
  .iInp {
    width: 270px;
  }
}

.radioContent {
  padding-top: 12px;
}

.pagefoot {
  height: 60px;
  line-height: 60px;
  background: white;
  padding-left: 20px;
  position: relative;
  z-index: 2;
  .btn {
    height: 32px;
    padding: 0 12px;
    margin-right: 12px;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
  }
  .type1 {
    line-height: 32px;
    background: rgb(86, 119, 252);
    color: white;
  }
  .type2 {
    box-sizing: border-box;
    border: 1px solid #aeaeae;
    line-height: 30px;
  }

  .loading {
    font-size: 14px;
    padding-left: 24px;
    color: #aeaeae;
    i {
      font-size: 18px;
      vertical-align: middle;
    }
  }
}
</style>

<style lang="css">
.pgInner.euserEdit .el-input__inner {
  border-radius: 0px !important;
}

.pgInner.euserEdit .el-form-item {
  display: inline-block !important;
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// listEdit.vue?31c0299e